export default __webpack_public_path__ + "static/media/default.c88d1c80c1b74dbab675b26789e02598.svg";